import React, { useEffect, useState } from 'react';
import Heading from '../../Atoms/Heading/Heading';
import { getStoreIDByURL, updateOrderViewModel } from '../../../Utils/componentUtils';
import { Card } from '../Card/Card';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import CartModal from '../CartModal/CartModal';
import useStore from '../../../store/useStore';
import './FavoriteOrBestseller.scss';
import { productString } from '../../Analytics/AnalyticsNew';
import classNames from 'classnames';
import {
  CardKeys,
  FavBestSellarResponse,
  SlickSliderProps,
} from '../../Interfaces/FavoriteOrBestSellerInterface';
import CustomSlider from '../CustomSlider/CustomSlider';
import UseWindowWidth from '../../../hooks/useWindowWidth';
import {
  ACCOUNT,
  BESTSELLER,
  FAVORITE,
  MENU,
  VIEWALL,
  PROFILE_PAGEVIEW,
} from '../../../constants/AnalyticsConstants';
import useRequest from '../../../hooks/useRequest';
import Skeleton from '../../Templates/Skeleton/Skeleton';
import EmptyResponse from '../EmptyResponse/EmptyResponse';
import { ADD_TO_CART_MESSAGE, REGULAR_IMG } from '../../../constants/App';
import ToastBannerContainer from '../../../hooks/ToastBannerContainer';
import { multipleAndCheck, multipleOrCheck, componentRenderCheck, ternaryCheck } from '../../../Utils/WindowUtils';
import FavOrBestConfirmationModal from './FavOrBestConfirmationModal';
import Link from '../../Atoms/Link/Link';
/**
 *
 * @param {string} Title heading text, level h1
 * @param {string} description description paragraph
 * @param {string} apiRoot API endpoint to get data for slides
 * @param {boolean} isFavourite is favourite list or not
 * @returns Reusable slider component
 */
const FavoriteOrBestseller: React.FC<SlickSliderProps> = ({
  apiEndpoint,
  isFavourite,
  siteName,
  orderViewModel,
  dataSource,
  isLoggedIn,
  categoryId,
  defaultStoreId,
  okText,
  language,
  params,
  shouldRenderCustomSlider = false,
  isShowSkeleton = true,
}) => {
  const [dataList, setDataList] = useState([]);
  const [favDictonary, setFavDictonary] = useState<any>({});
  const [bsDictonary, setBSDictonary] = useState<any>({});
  const [isModal, setIsModal] = useState<boolean>(false);
  const [apiFavoriteEndpoint, setApiFavoriteEndpoint] = useState<string>();
  const [unavailableApiEndPoint, setUnavailableApiEndPoint] = useState<string>();
  const [favoriteCartData, setFavoriteCartData] = useState<any>(null);
  const [reOrderDictonary, setReOrderDictonary] = useState<any>({});
  const [wantToRemove, setWantToRemove] = useState<boolean>(false);
  const [localState, setLocalState] = useState<any>({});
  const [apiEndpoints, setApiEndpoints] = useState<any>({});
  const[isViewClick, setIsViewClick] = useState<boolean>(false);
  const {
    showFavourite,
    isSetFavourite,
    isBestSeller,
    setAnalyticsProducts,
    setToastBanner,
    showToastBanner,
    setAttemptTracker,
    setPageLoadAnalytics,
    pageLoadAnalytics,
    setTotalCards,
    setSelectedCard,
    setNoOfComponents,
    noOFComponents,
    setContextLoader,
    setContextCardLoader,
  } = useStore();
  const [cartItemId, setCartItemId] = useState<string>();
  const [productName, setProductName] = useState<string>();
  const [error, setError] = useState<any>({});
  const [storeClose, setStoreClose] = useState<boolean>(false);
  const favDataSourceID = isFavourite && dataSource;
  const slidesToShow = ternaryCheck(UseWindowWidth() <= 600, 2, 4);
  const accountOrMenu = ternaryCheck(shouldRenderCustomSlider, MENU, ACCOUNT);
  const {setCartQuantity} = useStore();
  const apiPayload =
    ternaryCheck(multipleAndCheck(!isFavourite, !isSetFavourite),
      {
        DefaultStoreId: defaultStoreId?.value,
        SelectedStoreId: orderViewModel?.store?.id ?? 0,
        CategoryId: categoryId?.value,
        CultureCode: siteName,
        BestSellerDatasourceId: dataSource,
      },
      {
        StoreId: getStoreIDByURL(),
        isDashboard: true,
        IsDefaultStoreId: false,
        sitename: siteName,
        FavoritesDatasourceId: dataSource,
      });
        

  const { data: favBestSellarResponse, isLoading: dataLoading } = useRequest({
    params: {
      ...apiPayload,
      apiEndpoint: apiEndpoint.value,
      IsJsonResponse: true,
      cacheDuration: params.CacheDuration,
    },
  });
  const bestSellerLdFlag = (window as any).client?.variation(
    (window as any).FF_BEST_SELLERS_ENABLED,
    true,
  );
  const favoritesLdFlag = (window as any).client?.variation(
    (window as any).FF_SHOW_FAVORITES,
    true,
  );
  const ldFlagCheck = ternaryCheck(isFavourite ?? false, favoritesLdFlag, bestSellerLdFlag);
  useEffect(() => {
    if (dataList?.length > 0) {
      setTotalCards(dataList.length);
      if(accountOrMenu==ACCOUNT) {
        setAttemptTracker([{ name: PROFILE_PAGEVIEW }]);
      }      
    }
  }, [dataList]);

  useEffect(() => {
    if (multipleAndCheck(showToastBanner , !shouldRenderCustomSlider)) {
      setToastBanner({
        message: ADD_TO_CART_MESSAGE,
        type: 'success',
      });
    }
  }, [showToastBanner]);

  useEffect(() => {
    if (multipleAndCheck(!isLoggedIn , favBestSellarResponse?.bestSeller?.length > 0)) {
        setDataList(favBestSellarResponse.bestSeller);
        setBSDictonary(favBestSellarResponse.dictionaryLables);
        isBestSeller();
        setPageLoadAnalytics(pageLoadAnalytics + 1);
      }
    
    if (isLoggedIn) {
      if (favBestSellarResponse) {
        setFavDictonary(favBestSellarResponse.dictionaryLables);
        if (favBestSellarResponse?.favorites?.length > 0) {
          setDataList(favBestSellarResponse.favorites);
          setApiFavoriteEndpoint(favBestSellarResponse.apiEndPoint);
          const { removeFavoriteAPI, apiEndPoint } = favBestSellarResponse;
          setApiEndpoints({ removeFavoriteAPI, apiEndPoint });
          showFavourite();
        }
        setPageLoadAnalytics(pageLoadAnalytics + 1);
      }
      if (favBestSellarResponse) {
        if (favBestSellarResponse?.bestSeller?.length > 0) {
          setDataList(favBestSellarResponse.bestSeller);
          setBSDictonary(favBestSellarResponse.dictionaryLables);
          isBestSeller();
        }
        setPageLoadAnalytics(pageLoadAnalytics + 1);
      }
      if (multipleAndCheck(
        isSetFavourite ,
        favBestSellarResponse?.bestSeller?.length > 0
      )) {
        setDataList([]);
        setBSDictonary({});
      }
    }
if (multipleAndCheck(favBestSellarResponse?.displayError , noOFComponents?.length > 1)) {
      noOFComponents.pop();
      setNoOfComponents(noOFComponents);
    }
    orderViewModel.categoryDisplayName = "";
    orderViewModel.save();
  }, [favBestSellarResponse, isLoggedIn, isSetFavourite]);
  const onCloseModal = () => {
    setAnalyticsProducts({});
    setIsModal(false);
  };

  const onViewClick = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    setIsViewClick(true);
    setContextLoader({
      buttonId: "view-button",
      isLoading: true,
      animationColor: 'grey'
    });
    setAnalyticsProducts({
      clickActionName: VIEWALL,
      componentTitle: FAVORITE,
    });
    setAttemptTracker([{ name: accountOrMenu, isClickable: true }]);
  };

  const onAnchorClick = (e: React.SyntheticEvent, details: any, index: number) => {
    e.stopPropagation();
    setSelectedCard(index + 1);
    setAnalyticsProducts({
      clickActionName: details.productName,
      componentTitle: BESTSELLER,
    });
    setAttemptTracker([{ name: accountOrMenu, isClickable: true }]);
  };
  
  const reOrderFavDetails = (res: FavBestSellarResponse) => {
    const favoriteData = _get(res, ['favorites', 0]);
    const successData = _get(res.responseBody, 'successUrl');
    const dictonaryData = _get(res, 'dictionaryLables', {});
    if (favoriteData && dictonaryData) {
      setFavoriteCartData(favoriteData);
      setReOrderDictonary(dictonaryData);
      setStoreClose(false);
      setError({});
      setUnavailableApiEndPoint(res.unavailableApiEndPoint);
      setAnalyticsProducts({ componentTitle: FAVORITE, clickActionName: favoriteData.productName });
      setAttemptTracker([{ name: accountOrMenu, isClickable: true }]);
      setIsModal(true);
    }
    if (res.favorites && res.favorites.length === 0 && !res.IsstoreOpen) {
      setReOrderDictonary(res.dictionaryLables);
      setFavoriteCartData(null);
      setStoreClose(true);
      setError({});
      setIsModal(true);
    }

    if (favoriteData) {
      const isAvailable = favoriteData.isAvailable;
      const ingredientsAvailable = favoriteData.areAllIngredientsAvailable;
      if (multipleAndCheck(isAvailable , ingredientsAvailable)) {
        window.location.href = `/${orderViewModel.headerFooterLanguageCodeRedirect}/locator`;
      }
    }

    if (successData) {
      const productDetails = {
        categoryName: res.responseBody.cartCurrentItem.analytics.categoryName,
        productName: res.responseBody.cartCurrentItem.analytics.productName,
        productId: _get(res,['responseBody','cartCurrentItem','productId'],''),
        price: res.responseBody.cartCurrentItem.totalLineItemPrice,
        quantity: res.responseBody.cartCurrentItem.quantity,
        size: res.responseBody.cartCurrentItem.productName
      }
      const productStringData = productString(
        res.responseBody.cartCurrentItem,
        productDetails,
        '',
        `${accountOrMenu}-favorites`,
        'favorite',
      );
      const toastedEvent = _get(productStringData, [0, 'ingredients', 'breadType'], []);
      orderViewModel.currentOrder.cartId ??= res.responseBody.cartId;
      reOrderSetAnalytice(toastedEvent,productStringData);
      orderViewModel.cartOpen = false;
      orderViewModel.save();
      updateOrderViewModel(orderViewModel, res.responseBody);
      setCartQuantity(res.responseBody.cartItemQuantity || res.responseBody.cartQuantity);
      localStorage.setItem("cartProgressBar", res.responseBody.cartQuantity);
    }
  };
  const reOrderSetAnalytice=(toastedEvent:any, productStringData:any)=>{
    setAnalyticsProducts({
      toasted: ternaryCheck(toastedEvent.length > 0 , 1 , 0),
      upsellProductAddedEvent: 0,
      cartOpen: ternaryCheck(multipleOrCheck( orderViewModel?.cartOpen , !orderViewModel?.currentOrder?.cartId), 1 , 0),
      cartID: orderViewModel.currentOrder.cartId,
      itemaddedtobag: 1,
      productPriceAdded: 1,
      productQuantityAdded: 1,
      ExtrasPriceAdded: 1,
      ComboPriceAdded: 1,
      MIAMPriceAdded: 1,
      products: productStringData,
      clickActionName: 'add to bag',
      componentTitle: 'favorites',
    });
    setAttemptTracker([{ name: 'addToBag' }]);
  }
  // call api to get data from API - given by the favourite API
  const { postRequest: mutateData } = useRequest({ isOnClick: true });

  const onClickHandler = async (cartItemIds: string, productNames: string, index: number) => {
    setSelectedCard(index + 1);
    setProductName(productNames);
    setCartItemId(cartItemIds);
    setContextCardLoader({
      cardId:cartItemIds,
    });

    await mutateData({
      StoreId: orderViewModel?.store?.id ?? getStoreIDByURL(),
      CurrentOrderCartId: orderViewModel?.currentOrder?.cartId,
      ReorderedItemCartItemId: cartItemIds,
      SiteName: siteName,
      IsReactResponse: true,
      OrderSourceType: isSetFavourite ? 'favorite' : 'Best sellers',
      ComboOriginSource:isSetFavourite ? 'n/a' : null,
      FavoritesDatasourceId: favDataSourceID,
      apiEndpoint: apiFavoriteEndpoint,
    })
      .then((res: FavBestSellarResponse) => {
        setContextCardLoader({
          cardId:'',
        });
    
        if (res) {
          reOrderFavDetails(res);
        }
      })
      .catch((e: { [key: string]: string }) => {
        if (e) {
          setContextCardLoader({
            cardId:'',
          });  
          setAnalyticsProducts({
            componentTitle: FAVORITE,
            clickActionName: productNames,
          });
          setAttemptTracker([{ name: accountOrMenu, isClickable: true }]);
          setError(e);
          setStoreClose(false);
          setReOrderDictonary({});
          setFavoriteCartData(null);
          setIsModal(true);
        }
      });
  };

  const initiateRemoveFavorite = (cartItemIds: string) => {
    if (shouldRenderCustomSlider) {
      return;
    }
    setWantToRemove(true);
    setLocalState({ cartItemIds });
  };

  const removeFavorite = () => {
    mutateData({
      apiEndpoint: _get(apiEndpoints, 'removeFavoriteAPI', null),
      cartItemId: _get(localState, 'cartItemIds', null),
    })
      .then(res => {
        if (res && _get(res, 'removedId')) {
          const filteredData = dataList.filter(
            (item: any) => item.cartItemId !== _get(res, 'removedId'),
          );
          setDataList(filteredData);
          setWantToRemove(false);
          setIsModal(false);
        }
      })
      .catch(err => {
        setAttemptTracker([{ name: 'errorMessage', isClickable: true }]);
        setAttemptTracker([{ name: 'favoritesAlert', isClickable: true }]);
      });
  };

  const closeModal = () => {
    setWantToRemove(false);
  };

  const renderCards = (dataLists: CardKeys[]) => {
    return dataLists.map((card: CardKeys, index: number) => (
      <Card
        key={`${index}-${card.productId}`}
        title={isFavourite ? card.favoriteName : card.productName}
        imageURL={card.image}
        inStock={card.inStock}
        isFavourite={isFavourite}
        redirectURL={card.url}
        onClickHandler={() => onClickHandler(card.cartItemId, card.productName, index)}
        onAnchorClick={(e: React.SyntheticEvent) => onAnchorClick(e, card, index)}
        productName={card.productName}
        index={card.productId}
        heartIconClickHandler={event => {
          event.stopPropagation();
          initiateRemoveFavorite(card.cartItemId);
        }}
        imageSize={REGULAR_IMG}
        cartItemId={card.cartItemId}
      ></Card>
    ));
  };
  return (
    <div className="favoriteOrBestseller">
      {componentRenderCheck(
        multipleAndCheck(showToastBanner, !shouldRenderCustomSlider),
        <ToastBannerContainer />,
      )}
      {componentRenderCheck(
        multipleAndCheck(dataLoading, shouldRenderCustomSlider, isShowSkeleton),
        <Skeleton count={slidesToShow} className={'single-slide'} flexContent={'row'} />,
      )}
      {componentRenderCheck(
        multipleAndCheck(dataLoading, !shouldRenderCustomSlider, isShowSkeleton),
        <Skeleton count={4} isHeading={true} flexContent={'row'} className={'my_fav_page'} />,
      )}
      {componentRenderCheck(
        ldFlagCheck,
        <div className={`slider__comp ${isFavourite ? 'slider__favorite' : 'slider__bestseller'}`}>
          <div className={'slider__container'}>
            {!_isEmpty(dataList) && (
              <>
                <div className="slider__groupName">
                  <div>
                    {
                      <Heading
                        className="slider__title"
                        level="h2"
                        testAutoId="favourite-main-heading"
                        title={
                          ternaryCheck(
                            shouldRenderCustomSlider,
                            favDictonary?.title,
                            favDictonary?.myFavorites,
                          ) ?? bsDictonary?.title
                        }
                      />
                    }
                    {shouldRenderCustomSlider && favDictonary?.addItemsToYourCart && (
                      <Heading
                        level="p"
                        className="slider__desc"
                        title={favDictonary.addItemsToYourCart}
                        testAutoId="should-render-custom-slider"
                      />
                    )}
                  </div>
                  {shouldRenderCustomSlider && favDictonary?.viewAll && (
                    <Link
                      text={favDictonary.viewAll}
                      href={favDictonary.viewAllLink}
                      className={`slider__viewAll ${isViewClick && 'menu_viewAll'}`}
                      onClick={onViewClick}
                      testAutoId="view-button"
                      data-testid="view-button"
                    />
                  )}
                </div>
                <div
                  className={classNames('slider__list', {
                    'slider__list--tiles': !shouldRenderCustomSlider,
                  })}
                >
                  {ternaryCheck(
                    shouldRenderCustomSlider,
                    <CustomSlider
                      isFavoriteOrBestseller={true}
                      slides={dataList.length}
                      customBackBtnText={favBestSellarResponse?.dictionaryLables?.previousForSlide}
                      customDoneBtnText={favBestSellarResponse?.dictionaryLables?.nextForSlide}
                      customNextBtnText={favBestSellarResponse?.dictionaryLables?.nextForSlide}
                    >
                      {renderCards(dataList)}
                    </CustomSlider>,
                    renderCards(dataList),
                  )}
                </div>
                {shouldRenderCustomSlider && <hr className="fav__line"></hr>}
              </>
            )}

            {multipleAndCheck(
              !shouldRenderCustomSlider,
              _isEmpty(dataList),
              !_isEmpty(favDictonary),
            ) && (
              <EmptyResponse
                dictionary={{
                  title: _get(favDictonary, 'myFavorites', null),
                  content: _get(favDictonary, 'favoritesEmptyContent', null),
                  ctaText: _get(favDictonary, 'start Order', null),
                }}
              />
            )}
          </div>

          {_get(favDictonary, 'favoritesDisclaimer', null) &&
            !_isEmpty(dataList) &&
            !shouldRenderCustomSlider && (
              <p className="my-favorites__disclaimer" data-testauto-id="my-fav-disclaimer">
                {_get(favDictonary, 'favoritesDisclaimer', null)}
              </p>
            )}
        </div>,
      )}
      {componentRenderCheck(
        isModal,
        <CartModal
          unavailableApiEndPoint={unavailableApiEndPoint as string}
          favDictonary={reOrderDictonary}
          unavailableData={[favoriteCartData]}
          cartItemId={cartItemId as string}
          errorData={error}
          showModal={isModal}
          updateModal={onCloseModal}
          okText={okText}
          siteName={siteName}
          orderViewModel={orderViewModel}
          storeClose={storeClose}
          language={language}
          productName={productName}
          value="menu"
          addToBagSource={accountOrMenu}
        />,
      )}

      {componentRenderCheck(
        wantToRemove,
        <FavOrBestConfirmationModal
          confirmationModalClose={() => {
            closeModal();
          }}
          confirmationModalDetails={favDictonary}
          confirmationModalCtaAction={() => {
            removeFavorite();
          }}
        />,
      )}
    </div>
  );
};
export default FavoriteOrBestseller;

